'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _state = require('../roap/state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var RoapCollection = {
  sessions: {},

  getSession: function getSession(id) {
    if (!this.sessions[id]) {
      this.sessions[id] = {};
    }
    return this.sessions[id];
  },
  deleteSession: function deleteSession(id) {
    if (this.getSession(id)) {
      delete this.sessions[id];
    }
  },
  getSessionSequence: function getSessionSequence(id, seqId) {
    var session = this.getSession(id);
    var sequence = void 0;
    if (!session[seqId]) {
      session[seqId] = {};
      session[seqId].state = _state2.default.createState();
    }
    return session[seqId];
  },
  deleteSessionSequence: function deleteSessionSequence(id, seqId) {
    if (this.getSessionSequence(id, seqId)) {
      delete this.sessions[id][seqId];
    }
  }
};

exports.default = RoapCollection;
//# sourceMappingURL=collection.js.map
